/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fixture_RemoveInputs */

const th_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบ`)
};

const en_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const ja_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

const es_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const pt_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

const id_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus`)
};

const fr_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const tl_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alisin`)
};

const vi_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá`)
};

const ko_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`삭제`)
};

const de_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const ru_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить`)
};

const tr_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaldır`)
};

const it_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi`)
};

const pl_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń`)
};

const uk_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалити`)
};

const hi_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाएँ`)
};

const ar_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف`)
};

const ms_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buang`)
};

const bn_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরান`)
};

const zh_tw2_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const zh_hk2_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const ur_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ہٹائیں`)
};

const fa_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف`)
};

const sw_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondoa`)
};

const nl_fixture_remove = /** @type {(inputs: Fixture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Fixture_RemoveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const fixture_remove = /** @type {((inputs?: Fixture_RemoveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fixture_RemoveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_fixture_remove(inputs)
	if (locale === "ja") return ja_fixture_remove(inputs)
	if (locale === "zh") return zh_fixture_remove(inputs)
	if (locale === "es") return es_fixture_remove(inputs)
	if (locale === "pt") return pt_fixture_remove(inputs)
	if (locale === "id") return id_fixture_remove(inputs)
	if (locale === "fr") return fr_fixture_remove(inputs)
	if (locale === "tl") return tl_fixture_remove(inputs)
	if (locale === "vi") return vi_fixture_remove(inputs)
	if (locale === "ko") return ko_fixture_remove(inputs)
	if (locale === "de") return de_fixture_remove(inputs)
	if (locale === "ru") return ru_fixture_remove(inputs)
	if (locale === "tr") return tr_fixture_remove(inputs)
	if (locale === "it") return it_fixture_remove(inputs)
	if (locale === "pl") return pl_fixture_remove(inputs)
	if (locale === "uk") return uk_fixture_remove(inputs)
	if (locale === "hi") return hi_fixture_remove(inputs)
	if (locale === "ar") return ar_fixture_remove(inputs)
	if (locale === "ms") return ms_fixture_remove(inputs)
	if (locale === "bn") return bn_fixture_remove(inputs)
	if (locale === "zh-TW") return zh_tw2_fixture_remove(inputs)
	if (locale === "zh-HK") return zh_hk2_fixture_remove(inputs)
	if (locale === "ur") return ur_fixture_remove(inputs)
	if (locale === "fa") return fa_fixture_remove(inputs)
	if (locale === "sw") return sw_fixture_remove(inputs)
	if (locale === "nl") return nl_fixture_remove(inputs)
	return en_fixture_remove(inputs)
});